import React, { Component } from 'react';
import { Footer } from 'antd/es/layout/layout';

interface FooterProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

class _FooterBlock extends Component<FooterProps> {
  render() {
    const { style } = this.props;
    return (
      <Footer
        style={{
          textAlign: 'center',
          background: '#f0f2f5',
          ...style,
        }}
      >
        RelaxTime ©{new Date().getFullYear()} Created by LFTeam
      </Footer>
    );
  }
}

export const FooterBlock = _FooterBlock;
